.group {
	display: flex;
	flex-direction: column;
	gap: 8px;
}

.errorMessage {
	color: var(--content-error);
}
